export enum MessageType {
  PLANE = 0,
  SYSTEM = 1,
  ADMIN = 2,
}

export enum SystemMessageType {
  CREATE_ROOM,
  CLEAN_ROOM,
  GIFT_BULLET,
  JOIN_USER,
  PICK,
  PICK_RESULT,
  BLOCK7,
  BLOCK8,
  BLOCK9,
  BLOCK10,
  BLOCK11,
  BLOCK12,
  BLOCK13,
  BLOCK14,
  BLOCK15,
  BLOCK16,
  BLOCK17,
  BLOCK18,
  BLOCK19,
  BLOCK20,
  INCHAT_NOTICE,
}

export interface UserDetail {
  id: string;
  nickname: string;
  level: number;
  hasThumbnail: boolean;
  todayComment: string;
  gasMask: boolean;
  familyNickname: string;
}

export interface Message {
  user: string;
  messageType: MessageType;
  contents: string | { systemMessageType: SystemMessageType, pick?: string };
}